// Storage helper for localstorage.
import { StorageHelper } from '@jotforminc/storage-helper';

export default class Storage {
  constructor(props = { adapter: 'cookie' }) { // cookie, localstorage
    this.adapter = props.adapter;
  }

  isAvailable() {
    try {
      if (this.adapter === 'localstorage') {
        StorageHelper.setLocalStorageItem({key:'jottest', value:'jottest'});
        StorageHelper.removeLocalStorageItem({key:'jottest'});
        return true;
      } else if (this.adapter === 'cookie') {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  get(key) {
    let val;
    switch (this.adapter) {
      case 'cookie':
        val = global.document.readCookie(key);
        break;
      case 'localstorage':
        val = global.localStorage.getItem(key);
        break;
      default:
    }
    return val;
  }

  set(key, value) {
    let val;
    switch (this.adapter) {
      case 'cookie':
        val = global.document.createCookie(key, value, 7); // 7 days for now
        break;
      case 'localstorage':
        val = global.localStorage.setItem(key, value);
        break;
      default:
    }
    return val;
  }

  delete(key) {
    let val;
    switch (this.adapter) {
      case 'cookie':
        val = global.document.eraseCookie(key); // 7 days for now
        break;
      case 'localstorage':
        val = global.localStorage.removeItem(key);
        break;
      default:
    }
    return val;
  }

  deleteAll(expression, options = '') {
    if (!expression) {
      return;
    }

    if (this.adapter === 'cookie') {
      console.error('This feature is implemented only for LocalStorage');
      return false;
    }

    const regex = new RegExp(expression, options);
    Object.keys(global.localStorage)
        .forEach((key) => {
          if (regex.test(key)) {
            this.delete(key);
          }
        });
  }
}
